import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "InvoiceElement",
  computed: {
    deliveryCondition: function deliveryCondition() {
      if (this.isDelivery) {
        return this.orderType === 'outdoor';
      }

      return true;
    }
  },
  props: {
    title: {
      required: true,
      type: String
    },
    value: {
      required: true,
      type: Number
    },
    orderType: {
      required: false
    },
    isDelivery: {
      required: false
    }
  }
};